import type { Nullable } from "@/types/utils";

// Mirrors buildDownloadFilename in screener_session.service.ts (~line 5001).
// If the backend naming logic changes, update this function to match.

/* eslint-disable no-control-regex */
const sanitize = (s: string) =>
  s
    .replace(/[\x00-\x1f\x7f/\\:*?"<>|]/g, "")
    .replace(/\s+/g, "_")
    .trim();
/* eslint-enable no-control-regex */

const extractExtension = (s3Uri: string): string => {
  const basename = s3Uri.split("/").pop() ?? s3Uri;
  const parts = basename.split(".");
  return parts.length > 1 ? (parts.pop()?.toLowerCase() ?? "") : "";
};

export const DOWNLOAD_FALLBACK_LABEL = "Download file";

export const buildFileDisplayName = (
  candidateName: Nullable<string>,
  jobTitle: string,
  createdAt: string,
  internalLabel: string,
  s3Uri: string,
): string => {
  const ext = extractExtension(s3Uri);
  const suffix = ext ? `.${ext}` : "";
  const sanitizedName = sanitize(candidateName ?? "");

  // No name means the backend serves the upload's original filename, falling
  // back to plain `file.<ext>` when it has none. The original filename is not
  // in the results payload, so any filename we print here would be a guess the
  // download can contradict — label the action instead (SRN-803).
  if (!sanitizedName) {
    return DOWNLOAD_FALLBACK_LABEL;
  }

  const date = createdAt.slice(0, 10);
  const parts = [sanitizedName];

  if (jobTitle) {
    parts.push(sanitize(jobTitle));
  }

  parts.push(date);

  if (internalLabel) {
    parts.push(sanitize(internalLabel));
  }

  return `${parts.join("_")}${suffix}`;
};
